import {
  ActionList,
  ActionListItem,
  Divider,
  GridItem,
  Link,
  PrimaryTag,
  Text,
} from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import qs from "qs";
import React from "react";
import { Trans } from "react-i18next";
import { useLocation } from "react-router-dom";

import { EmployerReferenceModal } from "./EmployerReferenceModal";
import { getReferenceDate } from "./utils";

type EmployerReferenceListProps = {
  field: components["schemas"]["EmploymentReferencesCheckField"];
  references: components["schemas"]["EmploymentReferencesCheckFieldValue"]["references"];
  onSave: (
    reference: components["schemas"]["EmploymentReferencesValue"],
    index: number
  ) => void;
  onDelete: (index: number) => void;
};

export function EmployerReferenceList({
  field,
  references,
  onSave,
  onDelete,
}: EmployerReferenceListProps) {
  const sortedReferences = references
    .map((reference, i) => ({ ...reference, index: i }))
    .sort(({ end_date }) => (end_date ? 1 : -1));

  const location = useLocation();
  const params = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  const selectedReference = params.reference;

  return (
    <GridItem>
      <ActionList>
        {sortedReferences.map((reference) => (
          <React.Fragment key={reference.index}>
            <ActionListItem
              testID="employer-reference-list"
              title={reference.first_name + " " + reference.last_name}
              tag={
                !reference.end_date && (
                  <PrimaryTag type="subtle">
                    <Trans>Current</Trans>
                  </PrimaryTag>
                )
              }
              trailing={
                <EmployerReferenceModal
                  defaultOpen={
                    !!selectedReference && selectedReference === reference.id
                  }
                  index={reference.index}
                  onSave={onSave}
                  requirePhone={field.require_phone}
                  requireEmail={field.require_email}
                  reference={reference}
                  onDelete={() => onDelete(reference.index)}
                  trigger={
                    <Link
                      linkStyle="monochrome"
                      textStyle="global/body-secondary"
                      testID={`employment-references-edit-reference-${
                        reference.index + 1
                      }-button`}
                    >
                      <Trans>Edit</Trans>
                    </Link>
                  }
                />
              }
            >
              <Text style="global/body-secondary" color="text-weak">
                {reference.reference_job_title}
              </Text>
              <Text style="global/body-secondary" color="text-weak">
                {getReferenceDate(reference)}
              </Text>
            </ActionListItem>
            <Divider />
          </React.Fragment>
        ))}
      </ActionList>
    </GridItem>
  );
}
